import "./News.module.css";
import Header from "@/reusable_sections/Header";
import AllArticles from "./sections/AllArticles";
import ApplicationCards from "./sections/ApplicationCards";
import JoinTheNextRetreat from "./sections/JoinTheNextRetreat";
import Footer from "@/reusable_sections/Footer";
export default function NewsPage() {
  return <div>
      <Header />
      <AllArticles />
      <ApplicationCards />
      <JoinTheNextRetreat />
      <Footer />
    </div>;
}